const SELECT_EDIT_MAP_POINT = 'SELECT_EDIT_MAP_POINT';

export {
  SELECT_EDIT_MAP_POINT,
};
